import { createContext, useContext, useEffect, useState } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "./firebase/firebase";
import { store } from "./store/store";
import { setProducts } from "./store/slices/product-slice";
import { convertFirebaseProducts } from "./conversorObjeto/product-converter";

const StoreContext = createContext();

// BUSCA COLEÇÃO PELO STORE ID
async function getCollectionByStore(resource, storeId) {
  const q = query(
    collection(db, resource),
    where("storeId", "==", String(storeId))
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
}

// BUSCA DOCUMENTO POR ID
async function getDocument(resource, id) {
  const ref = doc(db, resource, String(id));

  const snap = await getDoc(ref);

  if (!snap.exists()) return null;

  return {
    id: snap.id,
    ...snap.data(),
  };
}

// BUSCA PAGINA INICIAL PELO SLUG
// BUSCA PAGINA INICIAL PELO SLUG (DOC ID)
async function getPaginaInicialBySlug(slug) {
  const ref = doc(
    db,
    "paginaInicial",
    String(slug).toLowerCase()
  );

  const snap = await getDoc(ref);

  if (!snap.exists()) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data(),
  };
}

export function StoreProvider({ children, slug }) {
  const [storeData, setStoreData] = useState({
    loja: null,
    paginaInicial: null,
    sobreNos: null,
    products: [],
    categorias: [],
    marcas: [],
    tags: [],
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (!slug) {
      setLoading(false);
      setError("slug não informado");
      return;
    }

    async function loadStore() {
      try {
        setLoading(true);
        setError(null);

        // BUSCA PAGINA INICIAL PELO SLUG
        const paginaInicial = await getPaginaInicialBySlug(slug);

        if (!paginaInicial) {
          throw new Error("Loja não encontrada");
        }
// LOJA DESATIVADA
    if (paginaInicial.status === false) {
      throw new Error("Loja desativada");
    }
        // UID INTERNO DA LOJA
        const storeId = paginaInicial.storeId;

        // BUSCA RESTANTE DOS DADOS
        const [
          loja,
          sobreNosArray,
          products,
          categorias,
          marcas,
          tags,
        ] = await Promise.all([
          getDocument("lojas", storeId),
          getCollectionByStore("sobreNos", storeId),
          getCollectionByStore("products", storeId),
          getCollectionByStore("categorias", storeId),
          getCollectionByStore("marcas", storeId),
          getCollectionByStore("tags", storeId),
        ]);

       

        // FILTRA PRODUTOS ATIVOS
        const activeProducts = products.filter(
          (product) => product.ativo !== false
        );

        

        // NORMALIZA PRODUTOS
        const normalizedProducts = convertFirebaseProducts(activeProducts, {
          categorias,
          marcas,
          tags,
        });

        

        if (!isMounted) return;

        setStoreData({
          loja,
          paginaInicial,
          sobreNos: sobreNosArray[0] || null,
          products: normalizedProducts,
          categorias,
          marcas,
          tags,
        });

        store.dispatch(setProducts(normalizedProducts));
      } catch (err) {
        console.error("Erro ao carregar dados da loja:", err);

        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadStore();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  return (
    <StoreContext.Provider
      value={{
        storeData,
        loading,
        error,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  return useContext(StoreContext);
}